export default "__VITE_ASSET__c18a4b2c__"